export default "__VITE_ASSET__DJTf9vw9__"